var r = 10,
  e = 20,
  t = 30,
  o = 40,
  n = 50,
  a = 60,
  f = {
    trace: 10,
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60
  },
  c = {};
function i(r) {
  return "string" == typeof r ? f[r.toLowerCase()] : r;
}
Object.keys(f).forEach(function (r) {
  c[f[r]] = r;
});
export { e as DEBUG, n as ERROR, a as FATAL, t as INFO, r as TRACE, o as WARN, f as levelFromName, c as nameFromLevel, i as resolveLevel };
